'use client';

import { Session } from '@pickleballinc/lib/session';
import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { useAuth } from '@/permissions/AuthProvider';
import { Permission } from '@/permissions/permission';
import { PlayerData } from '@/types/players.types';
import { getWithBaseUrl } from '@/utils/helpers/getWithBaseUrl';

interface ManageSponsorsWrapperProps {
  player: PlayerData | undefined;
  slug: string;
  user?: Session;
}

export const ManageSponsorsWrapper = ({ player, slug, user }: ManageSponsorsWrapperProps) => {
  const { hasPermission } = useAuth();
  const isSuperAdmin = hasPermission(Permission.SUPER_ADMIN);

  return (user && user.uuid === player?.uuid) || isSuperAdmin ? (
    <CustomLink href={getWithBaseUrl(`/players/${slug}/profile/sponsors`)}>
      <Button variant='primary' type='button' className='mb-6 bg-experiment'>
        Manage sponsors
      </Button>
    </CustomLink>
  ) : null;
};
